import HttpRequest from './HttpRequest'

class SmsTemplateProvider extends HttpRequest {
  findAll () {
    return this.get('/sms-template')
  }

  findOne (id) {
    return this.get(`/sms-template/${id}`)
  }

  create (payload) {
    return this.post('/sms-template', payload)
  }

  update (id, payload) {
    return this.patch(`/sms-template/${id}`, payload)
  }

  softDelete (id) {
    return this.delete(`/sms-template/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/sms-template?page=${page}&limit=${limit}`, query)
  }
}

export default SmsTemplateProvider
